let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bmtqA")).then(() => parcelRequire('71z5t'));